import { useSelector } from "react-redux";
import { selectors } from "../../redux/features/loader/loaderSlice";
import loadingWebp from "../../assets/animations/loading-panel-kodo.webp"; // animado

export const ReduxLoader = () => {
  const visible =  useSelector(selectors.selectLoader);


  return (
    visible && (
      <div
        style={{
          position: "fixed",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          top: 0,
          left: 0,
          background: "#fff",
          width: "100%",
          height: "100%",
          zIndex: 10,
        }}
      >
        <picture>
          {/* WebP animado (rápido) */}
          <source srcSet={loadingWebp} type="image/webp" />
          {/* Fallback GIF */}
          <img
            src={loadingWebp}
            alt="Loading..."
            width={64}
            height={64}
            decoding="async"
            loading="eager"
            style={{ objectFit: "contain", width: "4rem", height: "4rem" }}
          />
        </picture>
      </div>
    )
  );
};
